import {Link} from "react-router-dom";
import { Container, Row } from 'react-bootstrap';

import LinkBox from "./LinkBox"
import "./Home.css"
import "./Common.css"

function Home()
{
    return (
        <div>
          <Container>
            <Row>
            <LinkBox name="Mosaics" href="Mosaics" image="assets/Mosaics.png" offset={1} />
            <LinkBox name="Fractals" href="Fractals" image="assets/Fractals.png" offset={0} />
              <LinkBox name="Games" href="Games" image="assets/Games.png" offset={1} />
              <LinkBox name="Lego Planets" href="LegoPlanets" image="assets/LegoPlanets.png" offset={0} />
              <LinkBox name="Neural Style" href="NeuralStyle" image="assets/NeuralStyle.png" offset={1} />
              <LinkBox name="MCU Actor Comparison" href="MCUActors" image="assets/MCUActors.png" offset={0} />
            </Row>
          </Container>
          <Link to="/Home" className="logo"></Link>
        </div>
      )
}

export default Home;